export default __webpack_public_path__ + "static/inventory-system-2-7b42107a9136be1b524f317ecd378d15.png";